import React from 'react'

type PossibleRef<T> = React.Ref<T> | undefined

/**
 * A utility to compose multiple refs together
 * It's basically a copy of the one implemented by radix
 * https://github.com/radix-ui/primitives/blob/main/packages/react/compose-refs/src/composeRefs.tsx
 */
export function composeRefs<T>(...refs: PossibleRef<T>[]) {
  return (node: T) =>
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(node)
      } else if (ref !== null && ref !== undefined) {
        ;(ref as React.MutableRefObject<T>).current = node
      }
    })
}
